'use client';

import { useMutation } from '@tanstack/react-query';
import { AUTH_QUERIES } from '../../infrastructure/auth/utils/queries';
import type {
  GenerateOtpRequest,
  GenerateOtpResponse,
  VerifyOtpRequest,
  VerifyOtpResponse,
  VerifyEmailRequest,
  VerifyEmailResponse,
  RegisterRequest,
  RegisterResponse,
  LoginRequest,
  LoginResponse,
  LogoutResponse,
} from '../../infrastructure/auth/utils/types';

export const useAuthService = () => {
  const useGenerateOtp = () =>
    useMutation<GenerateOtpResponse, unknown, GenerateOtpRequest>(AUTH_QUERIES.generateOtp());

  const useVerifyOtp = () => useMutation<VerifyOtpResponse, unknown, VerifyOtpRequest>(AUTH_QUERIES.verifyOtp());

  const useVerifyEmail = () =>
    useMutation<VerifyEmailResponse, unknown, VerifyEmailRequest>(AUTH_QUERIES.verifyEmail());

  const useRegister = () => useMutation<RegisterResponse, unknown, RegisterRequest>(AUTH_QUERIES.register());

  const useLogin = () => useMutation<LoginResponse, unknown, LoginRequest>(AUTH_QUERIES.login());

  const useLogout = () => useMutation<LogoutResponse, unknown, void>(AUTH_QUERIES.logout());

  return {
    useGenerateOtp,
    useVerifyOtp,
    useVerifyEmail,
    useRegister,
    useLogin,
    useLogout,
  };
};
